import { Box, Button } from '@capitalise/ui-design-system';
import { FC, ReactNode } from 'react';

interface ListCompanyItemProps {
  buttonText: string;
  chip?: ReactNode;
  company: { companyName: string; companyNumber: string };
  onButtonClick: (company: { companyName: string; companyNumber: string }) => void;
  disabled: boolean;
}

const ListCompanyItem: FC<ListCompanyItemProps> = ({
  buttonText,
  company,
  onButtonClick,
  chip,
  disabled,
}: ListCompanyItemProps) => (
  <Box
    height="xlarge"
    py="3xsmall"
    display="flex"
    justifyContent="space-between"
    alignItems="center"
  >
    <Box typography="body-16">
      {company.companyName}
      {chip ?? chip}
    </Box>
    <Button
      variant="outlined"
      baseColor="green"
      disabled={disabled}
      onClick={() => onButtonClick(company)}
    >
      {buttonText}
    </Button>
  </Box>
);

export default ListCompanyItem;
